import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataType } from 'src/app/global/forms/categoria-plano-conta-form/categoria-plano-conta-form.component';

@Component({
  selector: 'app-estabelecimento-form',
  templateUrl: './estabelecimento-form.component.html',
  styleUrls: ['./estabelecimento-form.component.css']
})
export class EstabelecimentoFormComponent implements OnInit {

pesquisaForm!: FormGroup;

  constructor(public dialogRef: MatDialogRef<EstabelecimentoFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.pesquisaForm = this.fb.group({
      urlGoogleMaps: ['', Validators.required],
      nomeComercio: ['', Validators.required],
      numeroCelularComDdd: ['', Validators.required],
      enderecoFisico: ['', Validators.required],
      status: ['', Validators.required],
      pesquisaMapaId: ['', Validators.required] 
    });
    if (this.data && this.data.id) {
    this.pesquisaForm.patchValue({
      pesquisaMapaId: this.data.id
    });
  }
  }

  
  onConfirm() {
      this.dialogRef.close(this.pesquisaForm.value);
}
onCancel(): void {
this.dialogRef.close();
}
}

